import AdminProductRequestContent from '../../components/Products/AdminProductRequestDetails/AdminProductRequestContent';

/**
 * Page for the admin/operator product request details view.
 */
export default function AdminProductRequestDetails() {


  return (
    <div data-testid="admin-product-request-details-page">
      <AdminProductRequestContent

      />
    </div>
  );
}
